import React from 'react';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';

const VideoDownload = ({ videoId }) => {
  const handleDownload = () => {
    const videoElement = document.getElementById(videoId);
    if (!videoElement) return;

    const link = document.createElement('a');
    link.href = videoElement.currentSrc;
    link.download = '';
    link.click();
  };

  return (
    <IconButton
      sx={{ position: 'absolute', top: 8, right: 50 }}
      onClick={handleDownload}
    >
      <DownloadIcon />
    </IconButton>
  );
};

export default VideoDownload;
